import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus, faSearch, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import "../Home.css"; // Assurez-vous que les styles sont chargés

const JobProcess = () => {
  const { t } = useTranslation();

  const steps = [
    {
      id: 1,
      icon: faUserPlus,
      title: t("textInscriptionCreateAccount"), // "Créer un compte"
      desc: t("textInscriptionCreateAccountText"),
      color: "#3a7bd5" // Bleu
    },
    {
      id: 2,
      icon: faSearch,
      title: t("textSearchJob"), // "Rechercher un emploi"
      desc: t("textSearchJob"), // Attention: vérifiez que vous avez bien une clé de trad différente pour la description
      color: "#00d2ff" // Cyan
    },
    {
      id: 3,
      icon: faPaperPlane,
      title: t("textHowToApply"), // "Postuler"
      desc: t("textHowToApplyText"),
      color: "#6f42c1" // Violet pour la fin
    }
  ];

  return (
    <section className="section-box process-section mt-80 mb-50">
      <div className="container">
        <div className="row align-items-center">
          
          {/* Colonne Image avec animation flottante */}
          <div className="col-lg-6 col-md-12 mb-50 text-center">
            <div className="process-image-wrapper wow animate__animated animate__fadeInLeft">
                {/* Cercle décoratif en arrière plan */}
                <div className="blob-bg"></div>
                <img
                  className="img-fluid floating-anim position-relative z-1"
                  src="/assets/imgs/page/provided/5.png" 
                  alt="Processus de recrutement"
                />
            </div>
          </div>

          {/* Colonne Étapes */}
          <div className="col-lg-6 col-md-12">
            <div className="ps-lg-5">
                <h2 className="section-title mb-20 wow animate__animated animate__fadeInUp">
                    {t("textOurProcess")}
                </h2>
                <p className="text-muted mb-40 wow animate__animated animate__fadeInUp">
                    Décrochez le job de vos rêves en quelques clics. Voici comment ça marche :
                </p>

                <div className="process-list">
                    {steps.map((step, index) => (
                        <div 
                            key={step.id} 
                            className="process-step wow animate__animated animate__fadeInUp"
                            data-wow-delay={`${0.2 + (index * 0.1)}s`}
                        >
                            <div className="step-icon-wrapper">
                                <div className="step-number">{step.id}</div>
                                <div className="step-icon" style={{backgroundColor: `${step.color}15`, color: step.color}}>
                                    <FontAwesomeIcon icon={step.icon} />
                                </div>
                                {/* Ligne verticale de connexion (sauf pour le dernier) */}
                                {index !== steps.length - 1 && <div className="step-connector"></div>}
                            </div>
                            
                            <div className="step-content">
                                <h5 className="fw-bold mb-2">{step.title}</h5>
                                <p className="text-muted small mb-0">
                                    {step.desc}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Bouton d'action final */}
                <div className="mt-40 wow animate__animated animate__fadeInUp" data-wow-delay="0.5s">
                    <a href="/register" className="btn btn-gradient text-white fw-bold px-4 py-3">
                        Commencer maintenant
                    </a>
                </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JobProcess;